import { render, staticRenderFns } from "./roomDrag.vue?vue&type=template&id=123f8c16&scoped=true&"
import script from "./roomDrag.vue?vue&type=script&lang=js&"
export * from "./roomDrag.vue?vue&type=script&lang=js&"
import style0 from "./roomDrag.vue?vue&type=style&index=0&id=123f8c16&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123f8c16",
  null
  
)

export default component.exports